import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Antes de enviar',
  accountApproved: {
    met: 'Conta aprovada',
    missing: 'Conta em análise',
    hint: 'O envio libera depois que a Bodyprint aprovar a conta.',
  },
  addressLocated: {
    met: 'Endereço localizado',
    missing: 'Endereço não localizado',
    hint: 'O app ordena os eventos pela distância. Revise rua, número e cidade.',
  },
  upcomingDate: {
    met: 'Data futura',
    missing: 'A data já passou',
    hint: 'Escolha uma nova data para enviar.',
  },
  reviewAddress: 'Revisar endereço',
} satisfies TranslationTree;
